import { render, staticRenderFns } from "./TabEntidadFederativa.vue?vue&type=template&id=4901b307"
import script from "./TabEntidadFederativa.vue?vue&type=script&lang=js"
export * from "./TabEntidadFederativa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4901b307')) {
      api.createRecord('4901b307', component.options)
    } else {
      api.reload('4901b307', component.options)
    }
    module.hot.accept("./TabEntidadFederativa.vue?vue&type=template&id=4901b307", function () {
      api.rerender('4901b307', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/tasks/validaciones/constitucionsociedades/TabEntidadFederativa.vue"
export default component.exports